var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCantTrackWhatsWorkingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #70ce88;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.24,18.81c-.44.43-1.07.27-1.39-.08s-.35-.91.06-1.32l7.52-7.5c.81-.81,2.1-.9,3.1-.44l5.86,2.74c.36.17.78.04,1.06-.24l7.31-7.29c.39-.38.97-.31,1.3-.02.36.33.49.98.07,1.39l-7.45,7.41c-.82.81-2.09.97-3.1.5l-5.78-2.7c-.4-.18-.82-.2-1.16.13l-7.41,7.38Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.56,12.78h-2.34c-1.15,0-1.97.88-1.97,2.04v18.57c-.01,1.15.65,2.15,1.86,2.15h2.63c.99,0,1.81-.88,1.81-1.89V14.69c0-1.14-.96-1.91-1.99-1.91ZM33.66,33.65h-2.49V14.7h2.49v18.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.43,23.04l-2.43-.05c-1.1-.02-2.01.82-2.01,1.94v8.74c0,1.05.88,1.88,1.89,1.87h2.62c1.09-.02,1.79-.97,1.79-2v-8.61c0-1.08-.83-1.87-1.86-1.89ZM25.36,33.61h-2.47v-8.69h2.47v8.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.02,21.52c-.01-1.15-.92-1.91-2.01-1.91h-2.59c-1.21.23-1.72,1.15-1.72,2.32l.02,11.6c.01,1.15.82,2.02,1.96,2.02l2.51-.02c1.1,0,1.84-.94,1.84-1.99v-12.02ZM14.65,33.66v-12.14s2.47,0,2.47,0v12.14s-2.47,0-2.47,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.93,28.32c-.96-.03-1.9-.06-2.87.05-.94.1-1.61.96-1.61,1.88v3.44c.01,1,.88,1.85,1.89,1.85h2.64c1.05-.02,1.78-.96,1.78-1.91v-3.37c0-1.04-.77-1.91-1.83-1.94ZM8.83,33.65h-2.48v-3.42h2.48v3.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCantTrackWhatsWorkingIcon);
export default __webpack_public_path__ + "static/media/cant-track-whats-working-icon.bd5e3131340270169910d42f2b83143d.svg";
export { ForwardRef as ReactComponent };